'use strict';

var portal = require('@shadom/portal');
var validator = require('@shadom/validator');
var qs = require('qs');
var axios = require('axios');

var HEADER_KEYS;
(function (HEADER_KEYS) {
    HEADER_KEYS["CONTENT_TYPE"] = "content-type";
    HEADER_KEYS["USER_AGENT"] = "user-agent";
})(HEADER_KEYS || (HEADER_KEYS = {}));
var HEADER_CONTENT_TYPE;
(function (HEADER_CONTENT_TYPE) {
    HEADER_CONTENT_TYPE["URL_ENCODED"] = "application/x-www-form-urlencoded";
    HEADER_CONTENT_TYPE["TEXT_PLAIN"] = "text/plain";
    HEADER_CONTENT_TYPE["MULTIPART"] = "multipart/form-data";
    HEADER_CONTENT_TYPE["JSON"] = "application/json";
})(HEADER_CONTENT_TYPE || (HEADER_CONTENT_TYPE = {}));
function normalizeKeys(headers) {
    return Object.entries(headers).reduce((res, [key, value]) => {
        res[key.toLowerCase()] = value;
        return res;
    }, {});
}

// import { RamCache } from '@shadom/portal/dist/types/cache';
function genUri(uri, params) {
    for (let key in params) {
        uri = uri.replace(`:${key}`, encodeURIComponent(params[key]));
    }
    return uri;
}
class HttpPortal extends portal.Portal {
    method = 'get';
    axiosConfig = {};
    constructor(config, alias) {
        config.addr = config.addr || config.uri;
        alias = alias || {
            payload: ['queries', 'headers', 'data'],
            transmit: [],
        };
        super(config, {
            payload: alias.payload,
            transmit: alias.transmit,
        });
        // merge other axios options
        Object.assign(this.axiosConfig, config.axios);
        this.method = config.method;
    }
    async transmit(payloads) {
        let data = payloads.data;
        const headers = normalizeKeys(payloads.headers);
        if (headers[HEADER_KEYS.CONTENT_TYPE] === HEADER_CONTENT_TYPE.URL_ENCODED) {
            if (!validator.isStr(data)) {
                data = qs.stringify(data);
            }
        }
        let url = this.addr;
        if (payloads.pathParams) {
            url = genUri(this.addr, payloads.pathParams);
        }
        const res = await axios.request({
            url,
            method: this.method,
            headers: payloads.headers,
            responseType: payloads.responseType || 'json',
            params: payloads.params || payloads.queries,
            data,
            ...this.axiosConfig
        });
        return res;
    }
}

const methods = ['post', 'get', 'put', 'options', 'head', 'delete', 'connect', 'trace', 'patch'];

exports.HttpPortal = HttpPortal;
exports.methods = methods;
